import globalMU from "globalMU"
import { BaseApi } from "./BaseApi"

export class PermissaoFuncionalidadeApi extends BaseApi {

    async obterUsuarioPermitidoFuncionalidadeAcao(siglaFuncionalidade: string, acoes: string[]) : Promise<boolean> {
        

        const resposta = await this.api.post(`/Comum/UsuarioPermitidoFuncionalidadeAcao`,{
            siglaFuncionalidade: siglaFuncionalidade,
            acoes: acoes.filter(acao => globalMU.isNotNullOrEmpty(acao))
        })

        return resposta.data == "True"
    }
}